'use client'

import { useContext, useEffect } from 'react'
import { TranslationContext } from '@/phrase/context/TranslationContext'

export default function FontSwitcher() {
  const { locale } = useContext(TranslationContext)

  useEffect(() => {
    if (locale === 'th') {
      document.body.style.fontFamily = 'var(--font-kanit), sans-serif'
    } else {
      document.body.style.fontFamily = ''
    }
  }, [locale])

  return null
}
